var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _ellipse, _ellipse2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 15,
    height: 22,
    rx: 7.5,
    fill: "#D3D3D3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 15,
    height: 22,
    rx: 7.5,
    fill: "url(#paint0_radial_715_15546)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 15,
    height: 22,
    rx: 7.5,
    fill: "url(#paint1_linear_715_15546)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 15,
    height: 22,
    rx: 7.5,
    fill: "url(#paint2_radial_715_15546)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 15,
    height: 22,
    rx: 7.5,
    fill: "url(#paint3_radial_715_15546)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 15,
    height: 22,
    rx: 7.5,
    fill: "url(#paint4_radial_715_15546)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 15,
    height: 22,
    rx: 7.5,
    fill: "url(#paint5_radial_715_15546)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 15,
    height: 22,
    rx: 7.5,
    fill: "url(#paint6_radial_715_15546)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_715_15546)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.6367,
    y: 9.6792,
    width: 1.73568,
    height: 11.6659,
    rx: 0.867842,
    fill: "#6F6873"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 15,
    height: 22,
    rx: 7.5,
    fill: "url(#paint7_radial_715_15546)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 15,
    height: 22,
    rx: 7.5,
    fill: "url(#paint8_linear_715_15546)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 15,
    height: 22,
    rx: 7.5,
    fill: "url(#paint9_radial_715_15546)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    width: 7,
    height: 12,
    rx: 3.5,
    fill: "url(#paint10_linear_715_15546)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    width: 7,
    height: 12,
    rx: 3.5,
    fill: "url(#paint11_radial_715_15546)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 3.0625,
    y: 10,
    width: 7,
    height: 12,
    rx: 3.5,
    fill: "url(#paint12_linear_715_15546)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 3.0625,
    y: 10,
    width: 7,
    height: 12,
    rx: 3.5,
    fill: "url(#paint13_radial_715_15546)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.02805,
    cy: 13.0069,
    rx: 0.875089,
    ry: 1.11126,
    transform: "rotate(-39.7743 8.02805 13.0069)",
    fill: "url(#paint14_radial_715_15546)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.0241,
    cy: 13.0069,
    rx: 0.875089,
    ry: 1.11126,
    transform: "rotate(-39.7743 21.0241 13.0069)",
    fill: "url(#paint15_radial_715_15546)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_715_15546",
    x: 13.4367,
    y: 8.4792,
    width: 4.13633,
    height: 14.0658,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6,
    result: "effect1_foregroundBlur_715_15546"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_715_15546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0313 10.5) rotate(101.077) scale(21.1439 16.3514)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456846,
    stopColor: "#D8D0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707884,
    stopColor: "#D0B3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFABE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_15546",
    x1: -1.15625,
    y1: 17.625,
    x2: 8.48296,
    y2: 18.9314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.399485,
    stopColor: "#9B969E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A959E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_715_15546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8848 20.5405) rotate(-133.794) scale(20.0626 21.7161)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.844296,
    stopColor: "#9A959E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948591,
    stopColor: "#949296"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_715_15546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1029 19.5751) rotate(-155.387) scale(8.58398 20.8716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0216587,
    stopColor: "#D1AFE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1AFE5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_715_15546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.287 18.2074) rotate(-180) scale(5.55135 15.769)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABA5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABA5B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_715_15546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.7811 20.4601) rotate(-137.153) scale(7.57168 20.8624)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B689D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B689D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_715_15546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4577 9.06917) rotate(140.964) scale(3.51479 6.68569)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F2F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_715_15546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5937 12) rotate(103.51) scale(19.7978 15.3104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456846,
    stopColor: "#D8D0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707884,
    stopColor: "#D0B3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFABE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_715_15546",
    x1: 11.8438,
    y1: 17.625,
    x2: 21.3437,
    y2: 18.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.212017,
    stopColor: "#9B969E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A959E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_715_15546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4577 9.06917) rotate(140.964) scale(3.51479 6.68569)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F2F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_15546",
    x1: 19.5,
    y1: 10,
    x2: 19.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#232224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623C86"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_715_15546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4062 15.375) rotate(90) scale(6.625 2.17383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#443753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_715_15546",
    x1: 6.5625,
    y1: 10,
    x2: 6.5625,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#232224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623C86"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_715_15546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.46875 15.375) rotate(90) scale(6.625 2.17383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#443753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_715_15546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.04686 12.1597) rotate(127.514) scale(2.37685 2.50137)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_715_15546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.043 12.1597) rotate(127.514) scale(2.37685 2.50137)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/Eyes.98589093fb1b70551397a02c76055466.svg";
export { ForwardRef as ReactComponent };